import { createContext } from 'react'

import type { UseFullscreenModalProviderReturn } from './use-fullscreen-modal'

export type FullscreenModalContext = Partial<UseFullscreenModalProviderReturn>

export const FullscreenModalContext = createContext<FullscreenModalContext>({})
